import React from 'react'

function CheckBox2Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <rect
        x="1"
        y="1"
        width="20"
        height="20"
        rx="3"
        stroke="#65677D"
        stroke-width="2"
      />
    </svg>
  )
}

export default CheckBox2Icon
